export function isBrowserCompatibleForAi() {
  // Check if hasOwn property is supported (compatibility check workaround)
  return typeof Object.hasOwn === "function";
}
